export default __webpack_public_path__ + "static/media/E_Estrela.e0c11e52.svg";